/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisualizzazioneTipoPratica } from './visualizzazione-tipo-pratica';
import { CapabilitiesDTO } from './capabilities-dto';
import { TipoPraticaStato } from './tipo-pratica-stato';
import { TipologiaPratica } from './tipologia-pratica';
import { EconomiaDTO } from './economia-dto';


export interface TipoPraticaOperatoreDTO { 
    id?: string;
    codice?: string;
    titolo?: string;
    tipologia?: TipologiaPratica;
    stato?: TipoPraticaStato;
    comune_id?: string;
    comune_slug?: string;
    data_apertura?: string;
    data_chiusura?: string;
    visualizzazione?: VisualizzazioneTipoPratica;
    capabilities?: CapabilitiesDTO;
    economia?: EconomiaDTO;
    is_codice_anpr_enabled?: boolean;
    is_domanda_per_cittadino_unica?: boolean;
}



